import styled from 'styled-components';

const Modal = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1000;

	.content {
		padding: 20px;
		border-radius: 8px;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
		background-color: white;
		text-align: center;
		font-size: 24px;
		width: ${props => props.width || '60%'};
		height: ${props => props.height || '40%'};
		display: flex;
		justify-content: center;
		align-items: center;
	}
`;

export default Modal;
